import { setTitle } from "@store/title-store";
import { ErrorIndicator, Loader } from "@ui/indicators";

import { useLocation } from "react-router-dom";
import { useEffect, FC } from "react";
import NewsItems from "@components/news-components";
import { useNewsQuery } from "@lib/news";

const itemsPerPage = 16;

const SpecHelps: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Новости", href: "/news/help" },
      { title: "Полезные материалы", href: pathname },
    ];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isLoading, error, hasNextPage, fetchNextPage } = useNewsQuery({
    limit: itemsPerPage,
    type: "HELP",
  });

  return (
    <>
      {error ? (
        <ErrorIndicator />
      ) : isLoading ? (
        <Loader />
      ) : (
        data?.pages.map((page) => <NewsItems items={page.rows} path="help" />)
      )}
      {hasNextPage && (
        <button className="pagination-button" onClick={() => fetchNextPage()}>
          Показать еще
        </button>
      )}
    </>
  );
};

export default SpecHelps;
